import { useEffect } from 'react';

/**
 * Hook to update browser tab title.
 * @param {string} title - The name of the current page.
 */
const usePageTitle = (title) => {
  useEffect(() => {
    const baseTitle = "Papaya"; // fixed name
    
    if (title) {
      document.title = `${title} | ${baseTitle}`;
    } else {
      document.title = baseTitle;
    }
  }, [title]);
};

export default usePageTitle;
